import React from 'react';

import { useOutletContext } from 'react-router-dom';
import _ from 'lodash';

import { Datatable } from './Datatable';

export const DatatablePage = () => {
  const { termCode, crn, isCourseUpdatable } = useOutletContext();
  return <Datatable termCode={termCode} crn={crn} isUpdatable={isCourseUpdatable} />;
};
